import { CONSENT_DOMAIN } from '../../constants'

export const shouldShowConsentBannerSelector = () => {
  return (state) => {
    const consentState = state[CONSENT_DOMAIN]

    // Don't show if already shown
    if (consentState.hasShownBanner) {
      return false
    }

    // Don't show until client-side region detection completes
    // This prevents showing banner during SSR or before actual region is known
    if (!consentState.regionDetected) {
      return false
    }

    // Only show for EEA region users
    return consentState.isEeaRegion === true
  }
}
